import { mobileCSS } from '@measures/responsive'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import BulletpointsItem from './Item'

const BulletList = styled.ul`
  ${({
    theme: {
      fonts: { goodOT },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    list-style: none;
    margin: 0;
    padding-left: 0;
    font-family: ${goodOT};
    font-size: 19px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: 0.5px;
    line-height: 1.4;
    text-align: left;
    color: ${grey_100};

    ${mobileCSS(css`
      font-size: 18px;
    `)}
  `}
`

const Bulletpoints: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => <BulletList>{children}</BulletList>

export { Bulletpoints, BulletpointsItem }
